export const BuildingTableCellName = {
  AddressInvoice: 'address_invoice',
  AmountRestriction: 'amount_restriction',
  BankAccountOwner: 'bank_account_owner',
  BankBIC: 'bank_bic',
  BankIBAN: 'bank_iban',
  BankName: 'bank_name',
  BuildingGroups: 'building_groups',
  ConstructionYear: 'construction_year',
  ContractEnd: 'contract_end',
  ContractStart: 'contract_start',
  Created: 'created',
  DoorNumber: 'door_number',
  ExternalId: 'external_id',
  FlatCount: 'flat_count',
  FullAddress: 'full_address',
  HouseKeeper: 'house_keeper',
  InhabitantCount: 'inhabitant_count',
  InsuranceContractNumber: 'insurance_contract_number',
  InsuranceSupplier: 'insurance_supplier',
  InsuranceType: 'insurance_type',
  LivingType: 'living_type',
  Location: 'location',
  ObjectNumber: 'object_number',
  ORAGAccountant: 'orag_accountant',
  ORAGAssetManager: 'orag_asset_manager',
  ORAGBroker: 'orag_broker',
  ORAGIdenticalAddress: 'orag_identical_address',
  ORAGNumberOwner: 'orag_number_owner',
  ORAGTaxConsultant: 'orag_tax_consultant',
  ORAGWarranty: 'orag_warranty',
  PostalCode: 'postal_code',
  PropertyOwners: 'property_owners',
  RequestCategories: 'request_categories',
  ResponsibleUsers: 'responsible_users',
  Salutation: 'salutation',
  Street: 'street',
  Title: 'title',
  Updated: 'updated',
}
